import React, { createContext, useRef, useContext } from "react";
export const FloatingContainerContext = createContext(undefined);
const FloatingContainer = ({ children }) => {
    const floatingRef = useRef(null);
    return (React.createElement(FloatingContainerContext.Provider, { value: { ref: floatingRef.current } },
        React.createElement("div", { onContextMenu: (e) => e.stopPropagation(), onClick: (e) => e.stopPropagation(), ref: floatingRef }, children)));
};
export default FloatingContainer;
export const useFloatingContainerContext = () => {
    return useContext(FloatingContainerContext);
};
//# sourceMappingURL=FloatingContainer.js.map